import PropTypes from 'prop-types';

const optionShape = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  meta_id: PropTypes.number,
  value: PropTypes.node
});

export { optionShape };
